export const CUSTOM_REPORT_HEADER_AVERAGE_CHARACTER_WIDTH_PX = 8;
export const CUSTOM_REPORT_HEADER_HORIZONTAL_PADDING_PX = 32;
export const CUSTOM_REPORT_HEADER_HELP_ICON_WIDTH_PX = 24;
export const CUSTOM_REPORT_HEADER_SORT_ICON_WIDTH_PX = 20;

export const CUSTOM_REPORT_COLUMN_VISIBILITY_LOCAL_STORAGE_PREFIX =
  "custom-analytics-report-column-visibility:v1";

export const CUSTOM_REPORT_FILTERS_SEARCH_PARAM = "filters";
export const CUSTOM_REPORT_SORT_KEY_SEARCH_PARAM = "sortKey";
export const CUSTOM_REPORT_SORT_DIRECTION_SEARCH_PARAM = "sortDirection";

export const CUSTOM_REPORT_HELP_FORMULA_OPERATORS: ReadonlySet<string> =
  new Set(["=", "+", "-", "*", "/", "(", ")"]);

export const CUSTOM_REPORT_HELP_SENTENCE_TERMINATORS: ReadonlySet<string> =
  new Set([".", "!", "?"]);
